module.exports = __webpack_public_path__ + "img/w3_trash_delete_white.243423dd.png";